import React, { useRef, useState, useEffect } from "react";
import { Link } from 'react-router-dom';
import axios from "axios";
import { useTranslation } from 'react-i18next';
// componentes y estilos de Swiper
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation'; // Si quieres las flechitas
import 'swiper/css/pagination'; // Si quieres los puntitos abajo
// módulos de funcionalidad
import { Navigation, Pagination } from 'swiper/modules';
import './national-services.css'

import imgMexico from '../../../../assets/imgs/home-redesign/mexico.svg';
import iconGold from '../../../../assets/imgs/home-redesign/gold.svg';
import iconClock from '../../../../assets/imgs/home-redesign/clock.svg';
import iconMensajeria from '../../../../assets/imgs/home-redesign/mensajeria.svg';
import iconPerecederos from '../../../../assets/imgs/home-redesign/perecederos.svg';
import iconAltoValor from '../../../../assets/imgs/home-redesign/alto-valor.svg';
import iconAltaTec from '../../../../assets/imgs/home-redesign/alta-tecnologia.svg';
import iconAnimales from '../../../../assets/imgs/home-redesign/animales-vivos.svg';
import iconRestos from '../../../../assets/imgs/home-redesign/restos-humanos.svg';
import iconPharma from '../../../../assets/imgs/home-redesign/pharma.svg';
import iconValija from '../../../../assets/imgs/home-redesign/valija.svg';
import iconMercancia from '../../../../assets/imgs/home-redesign/mercancia-peligrosa.svg';
import iconServIndustria from '../../../../assets/imgs/home-redesign/servicios-industria.svg';
import { FaLongArrowAltRight, FaLongArrowAltLeft } from "react-icons/fa";

const NationalServices = () => {
    const [tNational] = useTranslation("national");
    const { i18n } = useTranslation();
    const [cards, setCards] = useState([]);
    const idNationals = "90b413b8-6b8a-48cd-92ee-a844807ac1a4";

    /* const cardsData = [
        { icon: iconGold, title: "Gold", text: "Servicio urgente, dedicado a embarques que son transportados en un vuelo específico, con prioridad en el abordaje y pronta entrega en el aeropuerto de destino.", url: "/servicios/nacionales/gold" },
        { icon: iconClock, title: "12+12", text: "Servicio no urgente de carga general, excepto mercancía clasificada. Nuestro servicio 12+12 ofrece el mejor precio y calidad en la entrega al día siguiente.", url: "/servicios/nacionales/doce+doce" },
        { icon: iconMensajeria, title: "Mensajería", text: "Servicio no urgente para embarques de hasta 3 Kg, cuyo contenido no requiera un manejo especial al mejor precio y calidad.", url: "/servicios/nacionales/mensajeria" },
        { icon: iconPerecederos, title: "Perecederos", text: "Servicio de mercancía clasificada, su conservación depende de un manejo adecuado y tiempos rápidos de traslado.", url: "/servicios/nacionales/perecederos" },
        { icon: iconAltoValor, title: "Alto Valor", text: "Servicio de mercancía clasificada , controla sus envíos más valiosos en todo momento contando con protección especializada para envíos donde la seguridad es fundamental.", url: "/servicios/nacionales/alto-valor" },
        { icon: iconAltaTec, title: "Alta Tecnología", text: "Servicio de mercancía clasificada ideal  para transportar equipos, aparatos de alta tecnología, ofreciendo un manejo especial en todo momento.", url: "/servicios/nacionales/alta-tecnologia" },
        { icon: iconAnimales, title: "Animales Vivos", text: "Servicio de mercancía clasificada, enfocado para el traslado de animales y mascotas de forma rápida y segura, donde ellos son lo más importante para nosotros.", url: "/servicios/nacionales/animales-vivos" },
        { icon: iconRestos, title: "Restos Humanos", text: "Servicio de mercancía clasificada, dirigido a las  funerarias, transportando  restos humanos o cenizas con una atención especializada y digna en esos momentos difíciles.", url: "/servicios/nacionales/restos-humanos" },
        // ... Agrega aquí tus otras 5 cards para llegar a 13 ...
        { icon: iconPharma, title: "Pharma XPS", text: "Servicio de mercancía clasificada dirigido al envío de vacunas y/o medicamentos  de manera urgente, (donde tú envío no puede esperar) obtendrás alta prioridad de recepción.", url: "/servicios/nacionales/pharma-express" },
        { icon: iconPharma, title: "Pharma STD", text: "Servicio urgente, dedicado a embarques que son transportados en un vuelo específico, con prioridad en el abordaje y pronta entrega en el aeropuerto de destino.", url: "/servicios/nacionales/pharma-estandar" },
        { icon: iconValija, title: "Valija", text: "Servicio dedicado a empresas de manejo de mensajería y paquetería en grandes volúmenes. Contarán con prioridad de abordaje y asignación de vuelo específico.", url: "/servicios/nacionales/valija" },
        { icon: iconMercancia, title: "Mercancía Peligrosa", text: "Servicio de mercancía clasificada dedicado a  envío de productos o sustancias peligrosas. Será importante cumplir con los requisitos  documentales y de embalaje.", url: "/servicios/nacionales/mercancia-peligrosa" },
        { icon: iconServIndustria, title: "Servicios para la industria", text: "Servicios especializados a empresas e industrias que requieren un servicio específico de acuerdo a sus necesidades.  Contacta a un ejecutivo (número).", url: "/servicios/nacionales/servicios-para-la-industria" },
    ]; */

    const baseConfig = {
        "Gold": { icon: iconGold },
        "12+12": { icon: iconClock },
        "Mensajeria": { icon: iconMensajeria },
        "Perecederos": { icon: iconPerecederos },
        "Alto Valor": { icon: iconAltoValor },
        "Alta Tecnología": { icon: iconAltaTec },
        "Animales Vivos": { icon: iconAnimales },
        "Restos Humanos": { icon: iconRestos },
        "Pharma XPS": { icon: iconPharma },
        "Pharma STD": { icon: iconPharma },
        "Valija": { icon: iconValija },
        "Mercancía Peligrosa": { icon: iconMercancia },
        "Servicios para la Industria": { icon: iconServIndustria },
    };

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await axios.get(
                    `${process.env.REACT_APP_URL_BACKEND}/api/textWeb/text/${idNationals}`,
                    {
                    headers: {
                        Authorization: process.env.REACT_APP_PUBLIC_KEY,
                    },
                    }
                );
                
                // Determinamos qué nodo del API usar según react-i18next
                // i18n.language suele devolver 'es' o 'en' (o 'en-US')
                const isSpanish = i18n.language.startsWith('es');
                const langKey = i18n.language.startsWith('es') ? 'text_es' : 'text_us';
                const apiData = response.data.textWeb[langKey];

                // Definimos la base de la URL según el idioma
                const urlBase = isSpanish ? '/servicios/nacionales/' : '/services/nationals/';

                // Mapeamos la configuración base con los datos del API
                const mergedData = Object.keys(baseConfig).map(key => {
                    const slug = apiData[key]?.["link-botón-linea"]?.trim() || "";

                    return {
                        ...baseConfig[key], // Trae icon y url
                        title: apiData[key]?.titulo || key, // Trae el título del API
                        text: apiData[key]?.texto || "" ,     // Trae el texto del API
                        url: `${urlBase}${slug}`
                    };
                });

                setCards(mergedData);
                console.log(cards);
            } catch (error) {
                console.error("Error cargando servicios:", error);
            }
        };

        fetchData();
    }, [i18n.language]); // Se vuelve a ejecutar si cambias el idioma

    const [showAll, setShowAll] = useState(false);

    // Creamos la referencia
    const topRef = useRef(null); 

    // Paso 1: Separamos los datos manualmente
    const mainCards = cards.slice(0, 8); // Las primeras 8
    const extraCards = cards.slice(8);   // De la 9 en adelante

    const handleToggle = () => {
        /* if (showAll) {
            topRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
        } */
        setShowAll(!showAll);
    };

    // Si showAll es true, usamos toda la lista. Si es false cortamos del 0 al 8.
    /* const visibleCards = showAll ? cardsData : cardsData.slice(0, 8); */

    return(
        <div className="container-fluid national-services px-0">
            <div className="row">
                <div className="col title-national">
                    <img src={imgMexico} />
                    <h3>{tNational("title.titulo de sección")}</h3>
                </div>
            </div>

            <div className="national-services-desktop">
                <div ref={topRef}></div>
                <div className="row mt-4 g-0">
                    {mainCards.map((card, index) => (
                        <div key={`main-${index}`} className="col-3 d-flex">
                            <div className="card-national">
                                <div className="mb-3">
                                    <div className="card-national-title">
                                        <img src={card.icon} alt={card.title} />
                                        <h5 className="align-self-end">{card.title}</h5>
                                    </div>
                                    <div className="card-national-text">
                                        <p>{card.text}</p>
                                    </div>
                                </div>
                                <Link 
                                    to={card.url} 
                                    className="btn-tertiary text-decoration-none" // text-decoration-none es para quitar el subrayado típico de los links
                                >
                                    {tNational("btn-learn-more")}
                                </Link>
                            </div>
                        </div>
                    ))}
                </div>
                <div className={`accordion-wrapper ${showAll ? 'open' : ''}`}>
                    <div className="accordion-inner">
                        <div className="row g-0"> {/* Importante: Otro 'row' adentro */}
                            {extraCards.map((card, index) => (
                            <div key={`extra-${index}`} className="col-3 d-flex">
                                {/* ... TU MISMO COMPONENTE CARD ... */}
                                <div className="card-national">
                                    <div className="mb-3">
                                    <div className="card-national-title">
                                        <img src={card.icon} alt={card.title} />
                                        <h5 className="align-self-end">{card.title}</h5>
                                    </div>
                                    <div className="card-national-text">
                                        <p>{card.text}</p>
                                    </div>
                                    </div>
                                    <Link 
                                        to={card.url} 
                                        className="btn-tertiary text-decoration-none" // text-decoration-none es para quitar el subrayado típico de los links
                                    >
                                        {tNational("btn-learn-more")}
                                    </Link>
                                </div>
                            </div>
                            ))}
                        </div>
                    </div>
                </div>
                {/* BOTÓN */}
                <div className="d-flex justify-content-center mt-4 mb-5">
                    <button className="btn-tertiary" onClick={handleToggle}>
                        {showAll ? tNational("btn-show-less") : tNational("btn-show-more")}
                    </button>
                </div>
            </div>

            <div className="national-services-tablet custom-padding">
                <div className="row">
                    <div className="col my-4 position-relative">

                        <div className="custom-prev nav-btn">
                            <FaLongArrowAltLeft size={18} />
                        </div>
                        <div className="custom-next nav-btn">
                            <FaLongArrowAltRight size={18} />
                        </div>

                        <Swiper
                            modules={[Navigation]}
                            spaceBetween={0} // Espacio entre cards (en px)
                            navigation={{
                                nextEl: '.custom-next',
                                prevEl: '.custom-prev',
                            }}
                            breakpoints={{
                                // Configuración para Celular (>= 320px)
                                320: {
                                    slidesPerView: 1, // Muestra 1 card
                                    spaceBetween: 10
                                },
                                // Configuración para Tablet (>= 768px)
                                768: {
                                    slidesPerView: 2, // Muestra 2 cards (¡Lo que pediste!)
                                    spaceBetween: 20
                                }
                            }}
                            className="mySwiper"
                        >
                            {/* Aquí iteramos TODAS las cards, sin separar en grupos */}
                            {cards.map((card, index) => (
                                <SwiperSlide key={index} style={{ height: 'auto' }}>
                                    {/* El 'height: auto' en el slide es clave para que Flexbox funcione dentro */}
                                    <div className="card-national"> 
                                        <div className="mb-0">
                                            <div className="card-national-title">
                                                <img src={card.icon} alt={card.title} />
                                                <h5 className="align-self-end text-nowrap">{card.title}</h5>
                                            </div>
                                            <div className="card-national-text">
                                                <p>{card.text}</p>
                                            </div>
                                        </div>
                                        <Link to={card.url} className="btn-tertiary align-self-start text-decoration-none">
                                            {tNational("btn-learn-more")}
                                        </Link>
                                    </div>
                                </SwiperSlide>
                            ))}
                        </Swiper>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default NationalServices;